import type { SVGProps } from 'react'

const TrendVisualizationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <rect width="60" height="60" fill="white" />
    <path
      d="M9.44434 45.5543V27.0943C9.44434 23.2228 13.6549 20.8201 16.988 22.7896L18.6223 23.7554C20.4467 24.8334 22.7526 24.6443 24.377 23.2833L38.7128 11.2723C40.6989 9.60822 43.6272 9.73716 45.4594 11.5693L54.6465 20.7565C55.5842 21.6941 56.111 22.9659 56.111 24.292V45.5542C56.111 48.3157 53.8724 50.5543 51.111 50.5543H14.4443C11.6829 50.5543 9.44434 48.3157 9.44434 45.5543Z"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.44434 39.4462L28.1477 30.3343C29.9455 29.4584 32.0922 29.738 33.6057 31.0451L40.6692 37.1454C42.2671 38.5254 44.5596 38.753 46.3976 37.7141L56.111 32.224"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33301 6.10938V47.776C3.33301 53.2989 7.81016 57.776 13.333 57.776H56.6663"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export default TrendVisualizationIcon
